var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolderNew = function SvgFolderNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.833 4.25a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V8a.75.75 0 0 0-.75-.75h-8.5l-1.057-2.538a.75.75 0 0 0-.693-.462zm.75 15V5.75h6.5l1.058 2.538a.75.75 0 0 0 .692.462h8.25v10.5zM8.891 14a.75.75 0 0 1 .75-.75h2.442V11a.75.75 0 0 1 1.5 0v2.25h2.443a.75.75 0 0 1 0 1.5h-2.443V17a.75.75 0 0 1-1.5 0v-2.25H9.641a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgFolderNew;